export const EXIT_POPUP_DEFAULT_CONFIG = {
    INITIAL_CHANCE: 20,
    PLAY_INCREASE_CHANCE: 5,
    CANCEL_DECREASE_CHANCE: 5,
    MAX_CHANCE: 50,
    MAX_APPEARANCES_PER_SESSION: 3,
};

export const EXIT_POPUP_LOCAL_STORAGE_KEY = 'orbitExitPopupData';

export const numberOfCorrelatedGames = 6;

